export const branchList = [
  {
    id: 1,
    name: "KD Rüsselsheim",
    street: "Karl-Landsteiner-Ring 1",
    city: "Rüsselsheim",
    postalCode: "65428",
    country: "Germany",
    lat: 49.97403347159630,
    lng: 8.449230412331850,
    email: "kundenservice@kd-ueberdachung.de",
    address: "Karl-Landsteiner-Ring 1, Rüsselsheim, 65428"
  },
  {
    id: 2,
    name: "KD Bielefeld",
    street: "Industriestraße 33-37",
    city: "Leopoldshöhe",
    postalCode: "33818",
    country: "Germany",
    lat: 51.97949180570240,
    lng: 8.708123055821650,
    email: "bielefeld@kd-ueberdachung.de",
    address: "Industriestraße 33-37, Leopoldshöhe, 33818"
  },
  {
    id: 3,
    name: "KD Ingolstadt",
    street: "Joseph-Baader-Straße 3",
    city: "Ingolstadt",
    postalCode: "85053",
    country: "Germany",
    lat: 48.73742,
    lng: 11.47116,
    email: "ingolstadt@kd-ueberdachung.de",
    address: "Joseph-Baader-Straße 3, Ingolstadt, 85053"
  },
  {
    id: 4,
    name: "KD Köln",
    street: "Armand-Peugeot-Str. 1B",
    city: "Köln",
    postalCode: "51149",
    country: "Germany",
    lat: 50.9044205,
    lng: 7.014957800000000,
    email: "koeln@kd-ueberdachung.de",
    address: "Armand-Peugeot-Str. 1B, Köln, 51149"
  },
  {
    id: 5,
    name: "KD Ulm",
    street: "Berliner Straße 27",
    city: "Senden",
    postalCode: "89250",
    country: "Germany",
    lat: 48.33377400000000,
    lng: 10.0362817,
    email: "ulm@kd-ueberdachung.de",
    address: "Berliner Straße 27, Senden, 89250"
  },
  {
    id: 6,
    name: "KD Würzburg",
    street: "Landwehrstraße 1",
    city: "Eisingen",
    postalCode: "97249",
    country: "Germany",
    lat: 49.7618952,
    lng: 9.839821300000000,
    email: "wuerzburg@kd-ueberdachung.de",
    address: "Landwehrstraße 1, Eisingen, 97249"
  },
  {
    id: 7,
    name: "KD Donaueschingen",
    street: "Dürrheimer Str 40",
    city: "Donaueschingen",
    postalCode: "78166",
    country: "Germany",
    lat: 47.96144350000000,
    lng: 8.5050245,
    email: "info@kd-donaueschingen.de",
    address: "Dürrheimer Str 40, Donaueschingen, 78166"
  },
  {
    id: 8,
    name: "KD Göppingen",
    street: "Daimlerstr. 11",
    city: "Eislingen/Fils",
    postalCode: "73054",
    country: "Germany",
    lat: 48.6953676,
    lng: 9.6854929,
    email: "goeppingen@kd-ueberdachung.de",
    address: "Daimlerstr. 11, Eislingen/Fils, 73054"
  },
  {
    id: 9,
    name: "KD Nürnberg",
    street: "Gewerbering 30",
    city: "Röttenbach",
    postalCode: "91341",
    country: "Germany",
    lat: 49.6590995,
    lng: 10.9175653,
    email: "nuernberg@kd-ueberdachung.de",
    address: "Gewerbering 30, Röttenbach, 91341"
  },
  {
    id: 10,
    name: "KD Saar/Mosel",
    street: "Mühlfelder Strasse 70",
    city: "Primstal",
    postalCode: "66620",
    country: "Germany",
    lat: 49.5279782,
    lng: 6.9646344,
    email: "saar-mosel@kd-ueberdachung.de",
    address: "Mühlfelder Strasse 70, Primstal, 66620"
  },
  {
    id: 11,
    name: "KD Bremen",
    street: "Neue Landstraße 9",
    city: "Hagen im Bremischen",
    postalCode: "27628",
    country: "Germany",
    lat: 53.366132,
    lng: 8.6777297,
    email: "bremen@kd-ueberdachung.de",
    address: "Neue Landstraße 9, Hagen im Bremischen, 27628"
  },
  {
    id: 12,
    name: "KD Hamburg",
    street: "Porschestr. 14",
    city: "Winsen (Luhe)",
    postalCode: "21423",
    country: "Germany",
    lat: 53.33594000000000,
    lng: 10.2181446,
    email: "hamburg@kd-ueberdachung.de",
    address: "Porschestr. 14, Winsen (Luhe), 21423"
  },
  {
    id: 13,
    name: "KD Hannover",
    street: "Vor dem Osterholze 5",
    city: "Lehrte",
    postalCode: "31275",
    country: "Germany",
    lat: 52.3684038,
    lng: 9.9991599,
    email: "hannover@kd-ueberdachung.de",
    address: "Vor dem Osterholze 5, Lehrte, 31275"
  },
  {
    id: 14,
    name: "KD Fulda",
    street: "Am Schützenhaus 5",
    city: "Hünfeld",
    postalCode: "36088",
    country: "Germany",
    lat: 50.6560962,
    lng: 9.665854200000000,
    email: "fulda@kd-ueberdachung.de",
    address: "Am Schützenhaus 5, Hünfeld, 36088"
  },
  {
    id: 15,
    name: "KD Dortmund",
    street: "Kurzer Morgen 17",
    city: "Schwerte",
    postalCode: "58239",
    country: "Germany",
    lat: 51.45771000000000,
    lng: 7.614840000000000,
    email: "dortmund@kd-ueberdachung.de",
    address: "Kurzer Morgen 17, Schwerte, 58239"
  },
  {
    id: 16,
    name: "KD Leipzig",
    street: "Dübener Landstraße 38",
    city: "Eilenburg",
    postalCode: "4838",
    country: "Germany",
    lat: 51.47537,
    lng: 12.6661599,
    email: "leipzig@kd-ueberdachung.de",
    address: "Dübener Landstraße 38, Eilenburg, 4838"
  },
  {
    id: 17,
    name: "KD Trier",
    street: "Loebstrasse 10 – 11",
    city: "Trier",
    postalCode: "54292",
    country: "Germany",
    lat: 49.774138,
    lng: 6.6737255,
    email: "trier@kd-ueberdachung.de",
    address: "Loebstrasse 10 – 11, Trier, 54292"
  },
  {
    id: 18,
    name: "KD Heilbronn",
    street: "Wilhelm-Hauff-Str. 52/3",
    city: "Bad Rappenau-Fürfeld",
    postalCode: "74906",
    country: "Germany",
    lat: 49.2107028,
    lng: 9.0661398,
    email: "heilbronn@kd-ueberdachung.de",
    address: "Wilhelm-Hauff-Str. 52/3, Bad Rappenau-Fürfeld, 74906"
  },
  {
    id: 19,
    name: "KD Berlin",
    street: "Drei Ruten 27",
    city: "Golßen",
    postalCode: "15938",
    country: "Germany",
    lat: 51.9475699,
    lng: 13.6478818,
    email: "berlin@kd-nbg.de",
    address: "Drei Ruten 27, Golßen, 15938"
  },
  {
    id: 20,
    name: "KD Limburg",
    street: "Mainzer Landstraße 13",
    city: "Hadamar",
    postalCode: "65589",
    country: "Germany",
    lat: 50.4468164,
    lng: 8.0454623,
    email: "limburg@kd-ueberdachung.de",
    address: "Mainzer Landstraße 13, Hadamar, 65589"
  },
  {
    id: 21,
    name: "KD Pforzheim",
    street: "Neuer Weg 24",
    city: "Niefern-Öschelbronn",
    postalCode: "75223",
    country: "Germany",
    lat: 48.9188023,
    lng: 8.7717317,
    email: "pforzheim@kd-ueberdachung.de",
    address: "Neuer Weg 24, Niefern-Öschelbronn, 75223"
  },
  {
    id: 22,
    name: "KD Polen",
    street: "Opolska 33",
    city: "Stradunia",
    postalCode: "47-341",
    country: "Poland",
    lat: 50.4114236,
    lng: 18.048271,
    email: "polska@kd-ueberdachung.pl",
    address: "Opolska 33, Stradunia, 47-341"
  },
  {
    id: 23,
    name: "KD Rumänien",
    street: "Str. Mihai Viteasul 192",
    city: "Sibiu",
    postalCode: "557265",
    country: "Romania",
    lat: 45.80347890000000,
    lng: 24.1449997,
    email: "office@kdromania.ro",
    address: "Str. Mihai Viteasul 192, Sibiu, 557265"
  },
  {
    id: 24,
    name: "KD Moldawien",
    street: "Bulevardul Dacia 47",
    city: "Chișinău",
    postalCode: "Moldova",
    country: "Moldova",
    lat: 46.97943620000000,
    lng: 28.8682589,
    email: "info@kd-uberdachung.md",
    address: "Bulevardul Dacia 47, Chișinău, Moldova"
  },
  {
    id: 25,
    name: "KD Wolfsburg",
    street: "Heinenkamp 4",
    city: "Wolfsburg",
    postalCode: "38444",
    country: "Germany",
    lat: 52.3697774,
    lng: 10.7404655,
    email: "wolfsburg@kd-ueberdachung.de",
    address: "Heinenkamp 4, Wolfsburg, 38444"
  },
  {
    id: 26,
    name: "KD Litauen",
    street: "Guobų g. 15",
    city: "Dumpiai Klaipėdos raj.",
    postalCode: "LT-95398",
    country: "Lithuania",
    lat: 55.64625730000000,
    lng: 21.240898,
    email: "info@kdvokiskosstogines.lt",
    address: "Guobų g. 15, Dumpiai Klaipėdos raj., LT-95398"
  },
  {
    id: 27,
    name: "KD Ungarn",
    street: "Bartók Béla u.12.",
    city: "Zalaszentgrot",
    postalCode: "8790",
    country: "Hungary",
    lat: 46.9524748,
    lng: 17.078959,
    email: "kd.ungarn@gmail.com",
    address: "Bartók Béla u.12., Zalaszentgrot, 8790"
  }
];
